import {Navigate} from 'react-router'

export const Home = () => <Navigate to="/search/firm" replace />
